const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bc1f58d5aa04b4cd50dcc6cc43bed4f62fddc4ad"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"bc1f58d5aa04b4cd50dcc6cc43bed4f62fddc4ad"};
      